<template>
  <div @contextmenu="tabRight($event)"
         @touchstart="touchstarts()"
         @touchmove="touchmoves()"
         @touchend="touchends()">
    <div class="swiper-container banner-box"
         v-if="Slidepictures.length!=0&&!rightSrc"
         style="overflow: hidden;width:100%;">
      <div class="swiper-wrapper">
        
        <a @click="openWindow(slide.aLink)"
           class="swiper-slide"
           style="text-align: center;"
           v-for="(slide,inx) in Slidepictures"
           :key="inx">
          <div class="introduction">
            <span class="introduction-t no-wrap">{{slide.mainTitle}}</span>
            <span class="introduction-b no-wrap">{{slide.subtitle}}</span>
          </div>
          <video width="100%"
                 @click.stop=""
                 class="vElement"
                 controls
                 webkit-playsinline="true"
                 playsinline="true"
                 :src="changeUrl(slide.pictureSrc)"
                 v-if="typeVideo(slide)"></video>
          <img v-else
               :src="changeUrl(slide.pictureSrc)"
               alt="">
        </a>
      </div>
      <div class="pagination"></div>
    </div>
    <!-- 右键链接展示开始 -->
    <div v-else-if="rightSrc"
         style="width:100%;height:339px">
      <!--切换一开始-->
      <iframe style="width:100%;height:100%"
              :src="rightSrc"
              frameborder="0"></iframe>
      <!--切换一结束-->
    </div>
    <!-- 右键链接展示结束 -->
    <div v-else
         class="defaultBack"></div>
  </div>
</template>
<script>
import Bus from '../bus.js'
export default {
  name: 'Banner',
  props: {
    blockData: {
      type: Object,
    },
    nodeId: {
      type: String,
    },
    pageType: {
      type: String,
      default: '0'
    },
    pictures: {
      type: Array
    },
    opt: {
      type: Object
    }
  },
  data () {
    return {
      timeOutEvent: 0,
      Slidepictures: [],
      rightSrc: '',
      autoPlay: 'on'
    }
  },
  watch: {
    "$store.state.rightSrc": function (val) {
      if (!this.rightSrc) {
        this.rightSrc = this.blockData.id == window.$floorflowId.id ? val : '';
      }
    }
  },
  computed: {
    outerWidth () {
      return window.innerWidth;
    },
    classType () {
      var type = '';
      if (this.pageType == 0) {
        type = 'round'
      }
      if (this.pageType == 1) {
        type = 'square'
      }
      if (this.pageType == 2) {
        type = 'rect'
      }
      return type;
    },
  },
  mounted () {
    var _this = this;
    if (_this.pictures[0] && _this.pictures[0].contentArr) {
      _this.pictures[0].contentArr.forEach((ite) => {
        let aLink = 'javascript:;', pictureSrc = '',mainTitle = '',subtitle='';
        ite.standardJson.forEach((it) => {
          if (it.standardData && it.standardData != '' && (it.standardData.indexOf('.png') > -1 || it.standardData.indexOf('.jpg') > -1 || it.standardData.indexOf('.mp4') > -1)) {
            pictureSrc = it.standardData;
          }
          if (it.standardData != '' && it.standardName == "链接地址") {
            aLink = it.standardData;
          }
          if (it.standardEnName == 'productBrief'){
            mainTitle = it.standardData;
          }
          if (it.standardEnName == 'tagline'){
            subtitle = it.standardData;
          }
        })
        if (pictureSrc != '' && (pictureSrc.indexOf('.png') > -1 || pictureSrc.indexOf('.jpg') > -1 || pictureSrc.indexOf('.mp4') > -1)) {
          _this.Slidepictures.push({ aLink: aLink, pictureSrc: pictureSrc, mainTitle: mainTitle,subtitle: subtitle });
        }
      })
    }
    _this.$http
        .get("/zciid-deliverable/api/abduction/getBannerType.json", {
          appId: _this.getQuery('appId')
        }).then(res => {
            _this.$nextTick(function () {
              new window.Swiper('.banner-box', Object.assign({}, {
                pagination: {
                  el: '.pagination',
                  clickable: true,
                  renderBullet: function (index, className) {
                    return `<span class="${className} ${_this.classType}">${_this.classType == 'square' ? (index + 1) : ''}</span>`;
                  },
                },
                autoHeight: true, //enable auto height
                autoplay: res.data&&res.data == 'off' ? false : {
                  delay: 5000,
                  disableOnInteraction: false,
                },
                // loop:true,
              }, _this.opt))
            })
        })
    
  },
  methods: {
    touchstarts () {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.tabRight();
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmoves () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchends (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    getBlockByFlowId (id) {
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getBlockDataListByFlowPid.json", {
          flowId: id
        })
        .then(res => {
          if (res.state == 1) {
            var Blockitem = res.data[0];
            return Blockitem;
          } else {
            this.getProduct([]);
          }

        }).then(Blockitem => {
          if (Blockitem) {
            this.getTagsByBlockId(Blockitem);
          }

        });
    },
    openWindow (link) {
      if (link && link != 'javascript:;') {
        // this.open(link);
        window.location.assign(link)
      }
    },
    tabRight (ev) {
      this.$store.commit('setFlowType', this.blockData.floorType);
      window.$changeFlowBlock = 'flow';
      window.$floorflowId = this.blockData;
      window.$nodeId = '';
      window.$floorflowId = '';
      if (this.blockData.id) {
        window.$floorId = this.blockData.id;
        window.$floorflowId = this.blockData;
      }
      if (this.nodeId) {
        window.$nodeId = this.nodeId;
      }
      Bus.$emit('windowRight', ev, 'block','banner');
      Bus.$emit('banner', 'close');
    },
    typeVideo (ite) {
      var isv = false;
      if (ite.pictureSrc) {
        if (ite.pictureSrc.indexOf('.webm') > 0 || ite.pictureSrc.indexOf('.mp4') > 0) {
          isv = true;
        }
      }
      return isv;
    }
  }
}
</script>
<style scoped>
.banner-box,
.banner-box img,
.banner-box video {
  width: 100%;
  height: 300px;
}
.pagination {
  position: absolute;
  z-index: 20;
  bottom: 10px;
  width: 100%;
  text-align: center;
}
.round {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0);
  cursor: pointer;
}
.round:after {
  content: "";
  display: block;
  position: absolute;
  left: 4px;
  top: 4px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 2px solid #b9beba;
  border-color: hsla(0, 0%, 100%, 0.4);
  -webkit-transition: background 0.2s ease;
  -o-transition: background ease 0.2s;
  -moz-transition: background ease 0.2s;
  transition: background 0.2s ease;
}
.round.swiper-pagination-bullet-active {
  background: hsla(0, 0%, 100%, 0.2);
}
.round.swiper-pagination-bullet-active:after {
  content: "";
  display: block;
  position: absolute;
  left: 4px;
  top: 4px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 2px solid #b9beba;
  border-color: #fff;
  background: #fff;
}

.rect {
  border-radius: 0;
  display: inline-block;
  width: 40px;
  height: 10px;
  position: relative;
  background: rgb(255, 255, 255);
  cursor: pointer;
}
.rect.swiper-pagination-bullet-active {
  background: rgb(255, 255, 255);
}

.square {
  border-radius: 0;
  font-size: 12px;
  display: inline-block;
  width: 16px;
  height: 16px;
  line-height: 16px;
  position: relative;
  background: rgb(255, 255, 255);
  cursor: pointer;
}
.square.swiper-pagination-bullet-active {
  background: rgb(255, 255, 255);
}
.swiper-slide{
  position: relative;
}
.swiper-slide .introduction {
  position: absolute;
  left: 50%; 
  top: 50%;
  transform: translate(-50%, -50%); 
  width: 1000px;
  color: #fff;
  text-align: left;
  font-weight: bold;
}

.swiper-slide .introduction-t {
  font-size: 32px;
  display: block;
}
.swiper-slide .introduction-b {
  margin-top: 20px;
  font-size: 18px;
  display: block;
}
@media screen   and (max-width: 768px) {
  .banner-box .swiper-wrapper {
    display: flex;
  }
  .banner-box,
  .banner-box img,
  .banner-box video {
    width: 100%;
    height: 150px;
  }
  .swiper-slide .introduction {
    width: 80%;
  }
  .swiper-slide .introduction-t {
    font-size: 2.4rem;
  }
  .swiper-slide .introduction-b {
    margin-top: 1.4rem;
    font-size: 1.4rem;
  }
}
@media screen and (max-width: 244px) {
  .banner-box .swiper-slide {
    width: 1920px;
    height: 150px;
  }
}
</style>
<style scoped>
.defaultBack {
  width: 100%;
  height: 300px;
  background-color: #ededed;
}
</style>


// WEBPACK FOOTER //
// src/components/Banner.vue